import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const phrases = [
  "Good things are allowed to happen",
  "Make today amazing",
  "Dream big",
  "Live freely",
  "Get used to good things happening",
];

export const EditorialMarquee = () => (
  <section data-testid="editorial-marquee" className="overflow-hidden border-y border-navy bg-navy py-6 md:py-8">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {phrases.map((p) => (
        <span key={p} className="mx-10 flex items-center gap-10 font-playfair text-2xl italic text-cream md:text-4xl">
          {p}
          <Sparkle className="h-5 w-5 fill-mustard text-mustard" />
        </span>
      ))}
    </Marquee>
  </section>
);
